import React, { useEffect, useState } from 'react'
import { SocialMediaMetricsCard, LeadsCard } from '../../../components'
import { handleApi } from '../../../utils/authentication'
import instagram from "../../../assests/instagram_1.svg"
import facebook from "../../../assests/facebook.png"
import twitter from "../../../assests/twitter.svg"
import linkedin from "../../../assests/linkedin_1.svg"
import { getPlatformImg } from '../../../helpers/getImgSrc'
import reports from "../../../assests/reports_active.png"
import LoadingSpinner from '../../../components/client/LoadingSpinner'
import NewOrganicSocialDashboard from './new_organic_social_dashboard/NewOrganicSocialDashboard'
import { getPlatformName } from '../../../helpers/getPlatformName'
import {useSelector} from 'react-redux'

const OwnedMedia = () => {

  const [dashboardData, setDashboardData] = useState({})
  const [leadsMetricsData,setLeadsMetricsData]=useState({ })
  const [loading,setLoading]=useState(false)
  const user=useSelector((state)=>state.user)
     const filter=useSelector((state)=>state?.filter?.filter_date_range)


  const getDashboardSocialMediaMetrics = async () => {
    try {
      setLoading(true)
        let formData = new FormData();
      formData.append('client_id', user?.client_id)
      if (filter?.days?.value == 'Custom Range') {
        formData.append('start_date', filter?.startDate)
        formData.append('end_date', filter?.endDate)
      } else if (filter?.value) {
        formData.append('days', filter?.value)
      }
      let metrics = [];
      let result = await handleApi(`get_dashboard_owned_media_metrics`, 'POST', {}, formData)
      if (result?.success) {


         metrics = Object.keys(result.organic_social_platforms_metrics).map(key => ({
          ...result.organic_social_platforms_metrics[key], // Copy object
           icon: getPlatformImg(result.organic_social_platforms_metrics[key].platform_id),
          // Add icon
           spend: result.organic_social_platforms_metrics[key].share,
          selectedPlatform:{
            platform_id:result?.organic_social_platforms_metrics[key]?.platform_id,
            platform_name:getPlatformName(result?.organic_social_platforms_metrics[key]?.platform_id)

          }
        }));
        let total = {
          name: 'OverView',
          share: result?.total?.share,
          spend: result?.total?.share,
          clicks: result?.total?.clicks,
          impressions: result?.total?.impressions,
          icon: reports
        }

        let facebook_metrics=[];
        let instagram_metrics=[];
        let linkedin_metrics=[]
        metrics?.forEach((data)=>{
          if(data?.name==="Facebook Posts")
          {
            facebook_metrics.push(data?.clicks)
            facebook_metrics.push(data?.impressions)
            facebook_metrics.push(data?.share)
          }
          if(data?.name==="Instagram Posts")
            {
              instagram_metrics.push(data?.clicks)
              instagram_metrics.push(data?.impressions)
              instagram_metrics.push(data?.share)
            }
            if(data?.name==="LinkedIn Posts")
              {
                linkedin_metrics.push(data?.clicks)
                linkedin_metrics.push(data?.impressions)
                linkedin_metrics.push(data?.share)
              }
           })
           
           setLeadsMetricsData({
            facebook:facebook_metrics,
            instagram:instagram_metrics,
            linkedin:linkedin_metrics
           })
        metrics?.push(total)

        setDashboardData((prev) => {
          return { ...prev, ...result, matrics: metrics }
        })
      }

    }
    catch (e) {
      console.log(e)

    }finally{
      setLoading(false)
    }

  }
 // console.log(dashboardData)

  useEffect(() => {
    getDashboardSocialMediaMetrics()
  }, [filter])



  let socialMediaData = {
    matrics: [
      {
        name: "Website",
        clicks: 0,
        impressions: 0,
        spend: 0,
        border_color: '#FFE58A'
      },
      {
        name: "Organic Social",
        clicks: dashboardData?.organic_social?.clicks ?? 0,
        impressions: dashboardData?.organic_social?.impressions ?? 0,
        spend: dashboardData?.organic_social?.share ?? 0,
        border_color: '#D3A4FF'
      },
      {
        name: "Content",
        clicks: 0,
        impressions: 0,
        spend: 0,
        border_color: '#FFB1E0'
      },
      {
        name: "Email Marketing",
        clicks: 0,
        impressions: 0,
        spend: 0,
        border_color: '#95F3FA'
      }

    ],
   
    total: {
      clicks: dashboardData?.total?.clicks ?? 0,
      impressions: dashboardData?.total?.impressions ?? 0,
      spend: dashboardData?.total?.share ?? 0,
      border_color: '#95F3FA'
    }
  }
  socialMediaData = { ...socialMediaData, matrics: dashboardData?.matrics }

 let barchart_graph_data=[
                      {
                          label: 'Facebook',
                          backgroundColor: '#D3A4FF', 
                          borderColor: '#D3A4FF',
                          borderWidth: 1,
                          data: leadsMetricsData?.facebook // Leads data
                      },
                      {
                          label: 'Instagram',
                          backgroundColor: '#FFB1E0', // Green bars
                          borderColor: '#FFB1E0',
                          borderWidth: 1,
                          data: leadsMetricsData?.instagram // Spent data
                      },
                       {
                          label: 'LinkedIn',
                          backgroundColor: '#FFE58A', // Red bars
                          borderColor: '#FFE58A',
                          borderWidth: 1,
                          data:leadsMetricsData?.linkedin 
                      }
              ]


 
  return (

    <div className='d-flex flex-column gap_lg'>
      {loading && <LoadingSpinner />}
      {!user?.status && <div className="d-flex justify-content-center align-items-center" >
        <div className="d-flex flex-column gap-2">
          <h5>Your account is Not Active</h5>
          <p>Please contact your administrator</p>
        </div>
      </div>}
      {!loading && user?.status && <>
        <SocialMediaMetricsCard socialMediaData={socialMediaData} keys={['Share', 'Impressions', 'Clicks']} />
        <LeadsCard bar_graph={true} pie_chart={false} labels={['Clicks', 'Impressions', 'Share']} heading="Clicks / Impressions /  Share" bar_graph_data={barchart_graph_data} 
      />
      
      <NewOrganicSocialDashboard   
      facebook_organic_social= {dashboardData?.facebook_total_metrics}
      instagram_organic_social={dashboardData?.instagram_total_metrics}
      linkedin_organic_social={dashboardData?.linkedin_total_metrics}
      top_performing_posts={dashboardData?.top_performing_posts}
      most_engaged_platform={dashboardData?.most_engaged_platform}

       
       />
      </>}
  
    </div>
  )
}

export default OwnedMedia